<template>
  <div class="canvas-wrap">
    <div
      id="map_canvas"
      ref="map_canvas"
    ></div>
  </div>
</template>
<script>
import { methods } from "../../utils/baidu-map/methods";
import { loadBMap } from "../../utils/baidu-map/loadResources";
const styleJson = require("../../utils/baidu-map/custom_map_config.json");
export default {
  name: "baidu-map-component",
  inject: ["app"],
  data() {
    return {
      citys: ["广州市", "嘉善县"],
      citys_overlays: [], // 每个区的label引用
      twelve_area_overlays: [], // 十二片区引用
      areaInfo: [],
      chartsData: 5,
      responeData: null,
      isLoadedMap: false,
      markers: [
        {
          lng: 113.50196178062878,
          lat: 23.18335925886588,
          part: "广州总部",
          company: "优鱼（广州）技术有限公司",
          phone: "020-85532423",
          address: "广东省广州市香雪八路98号F栋9楼904-905室",
        },
        {
          lng: 120.94991500560448,
          lat: 30.84019482401177,
          part: "浙江分公司",
          company: "优鱼（浙江嘉兴）技术有限公司",
          phone: "18344309099",
          address: "浙江省嘉兴市嘉善县晋阳东路568号11号楼604室",
        },
      ],
    };
  },
  components: {},
  computed: {},
  methods: {
    dosth() {},
    ...methods,
    // 初始化图表
    mapHandle() {
      // 主方法 **
      var map = new BMapGL.Map("map_canvas");
      this.app.map = this.map = map;
      map.setMapStyleV2({
        styleId: 'e0f484006b77be8751415194c36fefba',
      })
      // map.setMapStyleV2({ styleJson: styleJson });
      // 104.195397, 35.86166 北京市
      map.centerAndZoom(new BMapGL.Point(104.195397, 35.86166), 5);
      map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
      map.setMapType(BMAP_NORMAL_MAP); // 设置地图类型为地球模式：BMAP_EARTH_MAP; BMAP_NORMAL_MAP 正常模式
      // 隐藏图层
      // map.setDisplayOptions({
      //   layer: false,
      // });
      // map.addEventListener("click", function (e) {
      //   // 监听整张地图的鼠标点击事件
      //   console.log(e.latlng);
      //   alert("点击位置经纬度：" + e.latlng.lng + "," + e.latlng.lat);
      // });

      // 位置标记的属性
      var opts = {
        width: 350,
        height: 112,
        enableMessage: false,
        offset: new BMapGL.Size(0, 15), // 向下偏移
      };

      this.markers.forEach((item) => {
        // 创建添加点标记
        var marker = new BMapGL.Marker(new BMapGL.Point(item.lng, item.lat));
        map.addOverlay(marker);
        // 创建图文信息窗口
        var sContent = `
          <ul class="uppop-content">
                    <li><span>${item.part}：</span><span>${item.company}</span></li>
                    <li><span>电话：</span><span>${item.phone}</span></li>
                    <li><span>地址：</span><span>${item.address}</span></li>
                  </ul>
          `;
        var infoWindow = new BMapGL.InfoWindow(sContent, opts);
        // marker添加点击事件
        marker.addEventListener("mouseover", function () {
          this.openInfoWindow(infoWindow);
          // 图片加载完毕重绘infoWindow
          // document.getElementById("imgDemo").onload = function () {
          //   infoWindow.redraw(); // 防止在网速较慢时生成的信息框高度比图片总高度小，导致图片部分被隐藏
          // };

          this.addEventListener("mouseout", function () {
            setTimeout(() => {
              this.closeInfoWindow(infoWindow);
            }, 150);
          });
        });
      });

      // this.isLoadedMap = true;
    },
    // 清除覆盖物
    clearCurrentOverlays() {
      this.citys_overlays.map((ele) => {
        ele.enableMassClear();
      });

      this.twelve_area_overlays.map((ele) => {
        ele._listeners.onmouseover = {};
        ele._listeners.onclick = {};
      });
      this.map.clearOverlays();

      this.citys_overlays = [];

      return true;
    },
  },
  mounted() {
    // 模板编译/挂载之后
  },
  created() {
    window.initBaiduMapScript = () => {
      this.mapHandle();
    };
    loadBMap("initBaiduMapScript");
  },
  beforeDestroy() {
    // 组件销毁前调用
    // Tips：你确认删除XX吗？
  },
  destroyed() {
    // 组件销毁后调用
    // Tips：当前组件已被删除，清空相关内容
  },
  // 数据监听
  watch: {
    "$route.name": {
      handler(curVal, oldVal) {
        // this.map && this.clearCurrentOverlays() && this.map.reset();
      },
    },
  },
};
</script>
<style lang="less" scoped>
.canvas-wrap {
  width: 100%;
  height: 100%;
  position: absolute;
  .map_canvas {
    width: 100% !important;
    height: 100% !important;
  }
}

.uppop-content {
  font-family: "微软雅黑";
  font-size: 12px;
  font-weight: 400;
  color: #111e39;
  padding: 10px 20px;
}
.uppop-content li {
  list-style: none;
  padding: 0;
  margin: 0;
}
.uppop-content li:first-child,
.uppop-content li span:first-child {
  font-weight: 800;
}

/deep/ .area-point-num {
  text-align: center;
}

/deep/.uppop-content {
  font-family: "微软雅黑";
  font-size: 12px;
  font-weight: 400;
  color: #111e39;
  padding: 1.6rem 1rem !important;
  font-family: AlibabaPuHuiTi-Regular;

  li {
    list-style: none;
    margin: 0;
    margin-bottom: 4px;
    padding: 0 10px;
  }

  li:first-child,
  li span:first-child {
    font-weight: 800;
  }
}

// 百度地图实例节点
/deep/ #platform {
  .BMap_bubble_pop {
    // 默认宽度： 5.27rem高度 title + content = 1.88rem 另箭头height： 0.31rem； width 0.58rem；
    padding: 0 !important;
    border: 0 !important;
    border-radius: 0 !important;
    background: none !important;
    & > img {
      display: none;
    }
    .BMap_bubble_title,
    .BMap_bubble_top {
      visibility: hidden !important;
    }
    .BMap_bubble_buttons {
      // 关闭按钮
      visibility: hidden !important;
    }
    .BMap_bubble_center {
      // 主要容器位置
      background: none;
      height: 112px !important;
      width: 350px !important;
      .BMap_bubble_content {
        overflow: hidden !important;
        box-sizing: border-box;
        border-radius: 0.12rem;
        background: #fff !important;
      }
    }
  }
  .shadow img {
    display: none !important;
  }
}

.zyu-brand {
  .com-honor {
    display: none;
  }
}
</style>